import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  constructor() { }

  scrollToTop(){
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // for smooth scrolling
    });
  }

  rand() {
    return Math.random().toString(36).substr(2); // remove `0.`
  }

  generateToken() {
      return this.rand() + this.rand(); // to make it longer
  };

  generateRandomNumber4Digit(){
    var val = Math.floor(1000 + Math.random() * 9000);
    return val;
  }

  getShortDate(shortDate){
    var mydate = new Date(shortDate);
    var month = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"][mydate.getMonth()];
    var str = month + ' ' + mydate.getFullYear();
    return str;
  }

  addProduct(newProduct,list){
    if(list){
      list.push(newProduct);
    }else{
      list = [];
      list.push(newProduct);
    }
    return list;
  }

  calculateTotal(subtotal){
    return subtotal + this.calculateIva(subtotal);
  }
  

  calculateIva(value){
    return value*0.13;
  }

  goToCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02');
  }

  smartFind(
    obj: { [key: string]: string },
    search: string | number
  ): { variantId: string; databaseId: string } | undefined {
    const key = String(search); // normalize to string
  
    if (obj.hasOwnProperty(key)) {
      return { variantId: key, databaseId: obj[key] };
    }
  
    const entry = Object.entries(obj).find(([_, value]) => value === key);
    if (entry) {
      const [variantId, databaseId] = entry;
      return { variantId, databaseId };
    }
  
    return undefined;
  }

  getCurrentToken(){
    return 'ABCD'; /* this.currentTokenOrderCode; */
  }

}
